import { Reveal, RevealGroup, RevealItem } from "./Reveal";
import { Link } from "react-router-dom";
import { SERVICES } from "../../data/content";

export const Services = () => {
  return (
    <section
      id="sluzby"
      data-testid="services-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-brand-orange mb-3">
            Naše služby
          </p>
          <h2 className="font-heading font-black text-4xl sm:text-5xl text-brand-navy tracking-tight leading-none">
            S čím vám pomůžeme
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Klíče, autoklíče, zámky i nouzové situace řešíme rychle a prakticky
            v Ostravě.
          </p>
        </Reveal>

        <RevealGroup className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <RevealItem key={s.title}>
                <Link
                  to={s.href}
                  data-testid={`service-card-${s.title}`}
                  className="group relative block h-full hover:-translate-y-1.5 transition-transform duration-300"
                >
                  {/* Image with segmented / partial orange framing */}
                  <div className="relative">
                    <div className="relative rounded-2xl overflow-hidden aspect-[3/4] bg-brand-navy">
                      <img
                        src={s.img}
                        alt={s.title}
                        loading="lazy"
                        decoding="async"
                        className="h-full w-full object-cover transition-transform duration-[600ms] ease-out will-change-transform group-hover:scale-[1.05]"
                      />
                      {/* bottom gradient for depth */}
                      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-brand-navy/70 to-transparent" />
                    </div>

                    {/* partial corner brackets (top-left + bottom-right), overflow the image */}
                    <span className="pointer-events-none absolute -top-2 -left-2 h-12 w-12 border-t-[3px] border-l-[3px] border-brand-orange rounded-tl-xl transition-all duration-300 group-hover:h-16 group-hover:w-16" />
                    <span className="pointer-events-none absolute -bottom-2 -right-2 h-12 w-12 border-b-[3px] border-r-[3px] border-brand-orange rounded-br-xl transition-all duration-300 group-hover:h-16 group-hover:w-16" />

                    {/* icon badge */}
                    <span className="absolute top-3 right-3 grid place-items-center h-11 w-11 rounded-xl bg-brand-orange text-white shadow-lg shadow-brand-navy/30 transition-transform duration-300 group-hover:-translate-y-0.5">
                      <Icon className="h-5 w-5" strokeWidth={2.3} />
                    </span>
                  </div>

                  {/* title only, larger */}
                  <h3 className="mt-5 font-heading font-bold text-xl sm:text-2xl text-brand-navy tracking-tight">
                    {s.title}
                  </h3>
                  <span className="mt-2 block h-1 w-10 rounded-full bg-brand-orange transition-all duration-300 group-hover:w-16" />
                </Link>
              </RevealItem>
            );
          })}
        </RevealGroup>
      </div>
    </section>
  );
};

export default Services;
